const allMultitabsObjects = document.querySelectorAll('.js-multitabs');

const createLinks = (thisTab, content, allTabs) =>{
    const titleTab = thisTab.dataset.title;
    const contentLink = document.createElement('div');
    const active = thisTab.dataset.active;

    contentLink.innerText = titleTab;
    contentLink.classList.add('css-multitabs-links__link');
    contentLink.classList.add('js-multitabs-links__link');
    active === 'active' && contentLink.classList.add('link-active');
    
    contentLink.addEventListener('click', (e)=>{
        const allLinks = content.querySelectorAll('.js-multitabs-links__link');
        allLinks.forEach((link)=> link.classList.remove('link-active'));
        contentLink.classList.add('link-active');

        allTabs.forEach((contentTab) => contentTab.classList.remove('tab-active'));
        thisTab.classList.add('tab-active');
    })

    content.append(contentLink);
}

allMultitabsObjects.forEach((objectMultitab)=>{
    const linksContainer = objectMultitab.querySelector('.js-multitabs-links');
    const multitabs = objectMultitab.querySelectorAll('.js-multitabs-slides__content');
    
    multitabs.forEach((eachTab)=>{
        createLinks(eachTab, linksContainer, multitabs);

        const active = eachTab.dataset.active;
        if(active === 'active')eachTab.classList.add('tab-active');

    })

})



const allSlides = document.querySelectorAll('.js-multitabs-slides__content');

allSlides.forEach((slide)=>{
    const thisSlide = slide.querySelector('.js-init-slide');
    const prev = slide.querySelector('.prev-slide-multitabs');
    const next = slide.querySelector('.next-slide-multitabs');

    $(thisSlide).slick({
        arrows:false,
        slidesToShow:4,
        slidesToScroll:1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });
    $(prev).click(function(){
        $(thisSlide).slick('slickPrev')
    })
    $(next).click(function(){
        $(thisSlide).slick('slickNext')
    })
})

